import axiosInstance from "../AxiosInstance";

export const handleGetContent = async (data) => await axiosInstance.post('/content/getContent',data);
export const handleGenerateContent = async (data) => await axiosInstance.post('/content/generateContent', data);
export const handleUpdateContent = async (data) => await axiosInstance.put('/content/updateContent', data);